module.exports = __webpack_public_path__ + "img/fhlogo.47afe3a4.png";